import React, { FC } from 'react';
import { makeStyles, Theme } from '@material-ui/core/styles';
import { Box } from '@material-ui/core';
import Lottie from 'react-lottie';
import LOTTIE_JSON from '../../../../Assets/homeFeatures/on-demand.json';

export interface OnDemandVideoProps {

}

const OnDemandVideo: FC<OnDemandVideoProps> = (props) => {
    const classes = useStyles();

    return (
        <Box>
            <Lottie options={{
                autoplay: true,
                loop: true,
                animationData: LOTTIE_JSON
            }} />
        </Box>
    )
}

const useStyles = makeStyles<Theme, any>((theme) => ({

}));

export default OnDemandVideo;